// Trix 1.3.5's bundle assigned `this.Trix`, which under the rspack/webpack CJS
// wrapper binds to `module.exports` — so `window.Trix` never existed. Trix 2
// ends its bundle with an unconditional `window.Trix = Trix`.
//
// That global is load-bearing for the wrong reason. The iOS app's Trix video
// bridge gates its attachment path on `window.Trix && window.Trix.Attachment`
// (BusyPaws.mobile web_view_panel.dart) and, when that branch is live, builds
// the attachment with `new Trix.Attachment({ file })`. Only
// `Attachment.attachmentForFile` calls `setFile`; the bare constructor leaves
// `file` null. `trix.js`'s `if (attachment.file)` would then be false and the
// video would never upload at all — worse than the race it was meant to fix.
//
// Every app build in the field checks this global, and mobile users cannot be
// force-upgraded, so we keep it undefined and let the bridge take its working
// `editor.insertFile` fallback. Nothing in this app reads the global:
// mentions_controller.js imports the module directly (`import Trix from
// "trix"`), which is unaffected.
//
// Removable once the bridge no longer references `window.Trix` AND that build
// has full adoption.
if (typeof window !== "undefined" && window.Trix) {
  delete window.Trix;
}
